import { track } from '../analytics/index.js';
import { useConfig, usePrice } from '../state/hooks.js';

// Phase 5 (B2B / department ordering) will open a form here capturing
// name / email / department / phone, then POST to a Cloudflare Worker that
// creates a Xero Quote with the PNG preview attached.
export function RequestQuoteButton() {
  const config = useConfig();
  const price = usePrice();

  const handleClick = () => {
    track({ name: 'quote_requested' });
    // eslint-disable-next-line no-console
    console.log('[configurator] Request a Quote (stub — Phase 5)', { config, price });
  };

  return (
    <div className="quote">
      <p className="quote__prompt">Department purchase or need a formal quote?</p>
      <button type="button" className="quote__btn" onClick={handleClick}>
        Request a Quote
      </button>
    </div>
  );
}
